/* eslint-disable */

import type { Address } from "viem"
import type { Config } from "wagmi"
import { getAddress } from "viem"

import type { EmitEvent, Token } from "@/domains/core"
import type { MinimalPoolStore } from "@/domains/minimal-pool/minimal-pool-store"
import { EventEmitter } from "@/domains/library"
import { claimAllLpReward } from "@/domains/on-chain"

export type ClaimAllLpRewardInteractionParams = {
  account: Address
  chainId: number
  config: Config
  voterAddress: Address
  governanceToken: Token
  pairs: Array<MinimalPoolStore>
  rewardsForTable: Array<MinimalPoolStore>
  emitter: EventEmitter<EmitEvent>
  onClaimSuccess?: () => void
}

export const claimAllLpRewardsInteraction = async ({
  account,
  chainId,
  config,
  voterAddress,
  governanceToken,
  pairs,
  rewardsForTable,
  emitter,
  onClaimSuccess,
}: ClaimAllLpRewardInteractionParams) => {
  const initialState: {
    gauges: Array<string>
    gaugeTokens: Array<Array<string>>
  } = {
    gauges: [],
    gaugeTokens: [],
  }

  const { gauges, gaugeTokens } = pairs.reduce((state, pool) => {
    // is the pool address in the rewardsForTable array?
    const found = rewardsForTable.find((rewardPool) => {
      return getAddress(rewardPool.address.toViemAddress()) === getAddress(pool.address.toViemAddress())
    })
    if (found && pool.hasGauge && pool.gaugeAddress) {
      state.gauges.push(pool.gaugeAddress.toViemAddress())
      // Convert governanceToken.address to string (handles LcAddress objects)
      const tokenAddress =
        typeof governanceToken.address === "string"
          ? governanceToken.address
          : (governanceToken.address as { toViemAddress?: () => Address }).toViemAddress?.() ??
            String(governanceToken.address)
      state.gaugeTokens.push([tokenAddress])
    }
    return state
  }, initialState)

  if (gauges.length === 0) {
    emitter.emit("info", {
      title: "No LP rewards to claim",
      variant: "info",
    })
    return false
  }

  if (gaugeTokens.length === 0) {
    emitter.emit("info", {
      title: "No LP rewards to claim",
      variant: "info",
    })
    return false
  }

  emitter.emit("claiming-all-lp-rewards", {
    title: "Claiming all LP rewards",
    description: `Claiming rewards from ${gauges.length} pairs`,
    variant: "info",
  })

  const result = await claimAllLpReward({
    account,
    chainId,
    config,
    voterAddress,
    gauges,
    gtokens: gaugeTokens,
    bribes: [],
    btokens: [],
    tokenId: 0,
  })

  // console.log("_gauges, _gtokens, _bribes, _btokens", _gauges, _gtokens, _bribes, _btokens)
  if (!result) {
    emitter.emit("error-claiming-all-lp-rewards", {
      title: "Claim All LP rewards",
      description: "Error claiming all rewards",
      variant: "error",
    })
    return false
  }

  if (result.success === true) {
    onClaimSuccess?.()
    // rewardsQuery.refetch()
    emitter.emit("claimed-all-lp-rewards", {
      title: "Claim All LP rewards",
      description: `Claimed all rewards`,
      variant: "success",
    })
  }

  if (result.success === false) {
    emitter.emit("error-claiming-all-lp-rewards", {
      title: "Claim All LP rewards",
      description: result.error,
      variant: "error",
    })
    return false
  }
}
